module.exports = __webpack_public_path__ + "static/img/行业特性应用3.805a9129.png";